export default __webpack_public_path__ + "static/media/Q19.01dac0f5.jpg";